import { action, computed, observable, runInAction } from "mobx";
import { createContext } from "react";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { ICertificate } from "../models/certificate";
import { IEmployee } from "../models/employee";
import { ITechnicianCertificate } from "../models/techniciancertificate";
import { ITechnicianCertificateName } from "../models/techniciancertificatename";
import { ITechnicianCertificatePhoto } from "../models/techniciancertificatephoto";

class EmployeeStore {
  @observable employeeRegistry = new Map();
  @observable employeeSearchRegistry = new Map();
  @observable employee: IEmployee | null = null;
  @observable employeeCertificateByNameRegistry = new Map();
  @observable employeeCertificate: ITechnicianCertificateName | null = null;
  @observable loadingInitial = false;
  @observable uploadingFile = false;
  @observable submitting = false;
  @observable reload = 1;
  @observable target = "";
  @observable certificateRegistry = new Map();
  @observable certificate: ICertificate | null = null;
  @observable techniciancertificateRegistry = new Map();
  @observable techniciancertificatephotoRegistry = new Map();
  @observable jobpositionRegistry = new Map();
  @observable techniciancertificatephoto: ITechnicianCertificatePhoto | null = null;
  @observable employeeNoneCertificateRegistry = new Map();
  @observable employeeCertificateIdRegistry = new Map();

  @computed get employeesByName() {
    return Array.from(this.employeeSearchRegistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }
  @computed get employeeCertificatesByDate() {
    // return Array.from(this.employeeCertificateByNameRegistry.values()).sort(
    //   (a, b) => Date.parse(a.expiryDate) - Date.parse(b.expiryDate)
    // );
    return Array.from(this.employeeCertificateByNameRegistry.values());
  }

  @computed get certificatesByName() {
    return Array.from(this.certificateRegistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }

  @computed get techniciancertificatephotosById() {
    return Array.from(this.techniciancertificatephotoRegistry.values())
    ;
  }

  @computed get jobpositionsByName() {
    return Array.from(this.jobpositionRegistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }

  @computed get employeenonecertificatesByName() {
    return Array.from(this.employeeNoneCertificateRegistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }

  @action loadEmployees = async () => {
    this.loadingInitial = true;
    try {
      const employees = await agent.Employees.list();
      runInAction("loading empolyees", () => {
        this.employeeRegistry.clear();
        this.employeeSearchRegistry.clear();
        employees.forEach((employee) => {
          employee.dob = employee.dob.substr(0, 10);
          employee.startDate = employee.startDate.substr(0, 10);
          this.employeeRegistry.set(employee.email, employee);
          if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist") 
          this.employeeSearchRegistry.set(employee.email, employee);
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load Employee List Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load Employee List Error");
    }
  };

  @action loadEmployee = async (email: string) => {
    let employee = this.getEmployee(email);
    if (employee) {
      employee.dob = employee.dob.substr(0, 10);
      employee.startDate = employee.startDate.substr(0, 10);
      if (!Array.isArray(employee.projectType)) employee.projectType = employee.projectType.split(',');
      if (!Array.isArray(employee.company)) employee.company = employee.company.split(',');
      this.employee = employee;

      return employee;
    } else {
      this.loadingInitial = true;
      try {
        employee = await agent.Employees.details(email);
        runInAction("getting employee", () => {
          employee.dob = employee.dob.substr(0, 10);
          employee.startDate = employee.startDate.substr(0, 10);
          employee.projectType = employee.projectType.split(',');
          employee.company = employee.company.split(',');
          this.employee = employee;
          this.loadingInitial = false;
        });
        return employee;
      } catch (error) {
        runInAction("get employee error", () => {
          this.loadingInitial = false;
        });
        toast.error("get employee error");
        console.log(error);
      }
    }
  };

  // @action loadEmployeeCertificates = async () => {
  //     this.loadingInitial = true;
  //     try {
  //         const techniciancertificates = await agent.TechnicianCertificates.list();
  //         runInAction('loading Employee certificates', () => {
  //             techniciancertificates.forEach(techniciancertificate => {
  //                 this.techniciancertificateRegistry.set(techniciancertificate.id, techniciancertificate)
  //             });
  //             this.loadingInitial = false;
  //         });
  //     } catch (err) {
  //         runInAction('Load Employee Certificate List Error', () => {
  //             this.loadingInitial = false;
  //         });
  //         toast.error('Load Employee Certificate List Error');
  //     }
  // };

  @action loadCertificatesByEmployee = async (email: string) => {
    const params = new URLSearchParams();
    params.append("TechnicianEmail", email);
    this.loadingInitial = true;
    try {
      const employeeCertificates = await agent.TechnicianCertificates.search(
        params
      );
      this.employeeCertificateByNameRegistry.clear();
      this.employeeCertificateIdRegistry.clear();
      runInAction("loading employee certificate", () => {
        employeeCertificates.forEach((employeeCertificate) => {
          if (employeeCertificate.expiryDate !== null) {
            employeeCertificate.expiryDate =
              employeeCertificate.expiryDate.substr(0, 10);
          }
          this.employeeCertificateByNameRegistry.set(employeeCertificate.id,employeeCertificate);
          if (employeeCertificate.verified === "Y")
          this.employeeCertificateIdRegistry.set(employeeCertificate.certificateId,'');
        });
        this.loadingInitial = false;
      });
    } catch (err) {
      runInAction("load Employee Certificate List error", () => {
        this.loadingInitial = false;
      });
      toast.error("load Employee Certificate List Error");
    }
  };

  @action loadCertificates = async () => {
    this.loadingInitial = true;
    try {
      const certificates = await agent.Certificates.list();
      runInAction("loading certificates", () => {
        certificates.forEach((certificate) => {
          this.certificateRegistry.set(certificate.id, certificate);
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load Certificate List error", () => {
        this.loadingInitial = false;
      });
      toast.error("load Certificate List error");
    }
  };

  @action clearEmployee = () => {
    this.employee = null;
  };

  @action createEmployee = async (employee: IEmployee) => {
    this.submitting = true;
    try {
      if (employee.projectType !== '') employee.projectType = employee.projectType.filter((n: any) => n).toString();
      if (employee.company !== '') employee.company = employee.company.filter((n: any) => n).toString();
      await agent.Employees.create(employee);
      runInAction("create Employee", () => {
        this.submitting = false;
      });
    } catch (error) {
      runInAction("create Employee Error", () => {
        this.submitting = false;
      });
      toast.error("create Employee Error");
      console.log(error);
    }
  };

  @action editEmployee = async (employee: IEmployee) => {
    this.submitting = true;
    try {
      employee.projectType = employee.projectType.filter((n: any) => n).toString();
      employee.company = employee.company.filter((n: any) => n).toString();
      await agent.Employees.update(employee, this.employee!.email);
      runInAction("editing employee", () => {
        this.employeeRegistry.set(employee.email, employee);
        this.employeeSearchRegistry.set(employee.email, employee);
        employee.projectType = employee.projectType.split(',');
        employee.company = employee.company.split(',');
        this.employee = employee;
        this.submitting = false;
      });
    } catch (error) {
      runInAction("edit employee error", () => {
        this.submitting = false;
      });
      toast.error("edit employee error");
      console.log(error);
    }
  };

  @action deleteEmployee = async (email: string) => {
    this.submitting = true;
    this.target = email;
    try {
      await agent.Employees.delete(email);
      runInAction("deleting Employee", () => {
        this.employeeRegistry.delete(email);
        this.employeeSearchRegistry.delete(email);
        this.submitting = false;
        this.target = "";
      });
    } catch (error) {
      runInAction("delete Employee error", () => {
        this.submitting = false;
        this.target = "";
      });
      toast.error("delete Employee error");
      console.log(error);
    }
  };

  getEmployee = (email: string) => {
    return this.employeeRegistry.get(email);
  };

  @action searchEmployee = async (term: string) => {
      let employees = Array.from(this.employeeRegistry.values());
      if (term) {
        const selectedEmployees = employees.filter((employee) =>
          employee.name.toLowerCase().includes(term.toLowerCase()) || 
          employee.preferredName.toLowerCase().includes(term.toLowerCase())
        );
        this.employeeSearchRegistry.clear();
          selectedEmployees.forEach((employee) => {
            employee.dob = employee.dob.substr(0, 10);
            employee.startDate = employee.startDate.substr(0, 10);
         //   if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist")
            this.employeeSearchRegistry.set(employee.email, employee);
          });
      } else {
        this.employeeSearchRegistry.clear();
     //   employees = Array.from(this.employeeRegistry.values());
        employees.forEach((employee) => {
          employee.dob = employee.dob.substr(0, 10);
          employee.startDate = employee.startDate.substr(0, 10);
          if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist")
           this.employeeSearchRegistry.set(employee.email, employee);
        });
      }
  };

  @action deleteTechnicianCertificate = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.TechnicianCertificates.delete(id);
      runInAction('deleting TechnicianCertificate', () => {
        this.employeeCertificateByNameRegistry.delete(id);
        this.submitting = false;
        this.target = '';
      })
    } catch (error) {
      runInAction('delete TechnicianCertificate error', () => {
        this.submitting = false;
        this.target = '';
      })
      toast.error('delete TechnicianCertificate error');
      console.log(error);
    }
  }

  @action editEmployeeCertificate = async (techniciancertificate: ITechnicianCertificateName) => {
    this.submitting = true;
    try {
      await agent.TechnicianCertificates.update(techniciancertificate);
      runInAction('editing techniciancertificate', () => {
        this.employeeCertificateByNameRegistry.set(techniciancertificate.id, techniciancertificate);
       // this.employeecertificate = techniciancertificate;
        this.submitting = false;
      })
    } catch (error) {
      runInAction('edit techniciancertificate error', () => {
        this.submitting = false;
      })
      toast.error('edit techniciancertificate error');
      console.log(error);
    }
  };

  @action changeEmployeeCertificate = async (techniciancertificate: ITechnicianCertificateName, name: keyof ITechnicianCertificateName, value: string) => {
    techniciancertificate[name] = value;
    this.employeeCertificateByNameRegistry.set(techniciancertificate.id, techniciancertificate);
  };

  @action uploadPhoto = async (photo : File[], name : string, category : string) => {
    if (typeof photo !== 'undefined' && photo.length > 0) 
    {  
      this.uploadingFile = true;   
    try {
      // var photos : File[] = [];
      // photos.push(photo);
      await agent.Uploads.uploadPhoto(photo, name, category);
      runInAction(() => {
       this.uploadingFile = false;
       toast.success('Photo uploaded successfully!');
      });
    } catch (error) {
      console.log(error);
      toast.error('Problem uploading photo');
      runInAction(() => {
        this.uploadingFile = false;
      });
    }
  }
  };

  @action loadTechnicianCertificatePhoto = async (email: string, certificateId: string) => {
    this.loadingInitial = true;
    try {
      const techniciancertificatephotos = await agent.TechnicianCertificatePhotos.list(email, certificateId);
      runInAction('loading techniciancertificate photos', () => {
        this.techniciancertificatephotoRegistry.clear();
        techniciancertificatephotos.forEach(techniciancertificatephoto => {
          this.techniciancertificatephotoRegistry.set(techniciancertificatephoto.id, techniciancertificatephoto);
        });
        this.loadingInitial = false;
      })
    } catch (error) {
      runInAction('get techniciancertificate photo error', () => {
        this.loadingInitial = false;
      })
      toast.error('get techniciancertificate photo error');
      console.log(error);
    }
  }

  @action archiveTechnicianCertificate = async (email: string, certificateId: string) => {
    this.loadingInitial = true;
    try {
      await agent.TechnicianCertificatePhotos.archive(email, certificateId);
      runInAction('archive technician certificate', () => {
        this.techniciancertificatephotoRegistry.clear();
        this.loadingInitial = false;
      });
      toast.success('Archive completed successfully');
    } catch (error) {
      runInAction('archive techniciancertificate photo error', () => {
        this.loadingInitial = false;
      })
      toast.error('Archive error');
      console.log(error);
    }
  }

  getTechnicianCertificate = (id: string) => {
    return this.employeeCertificateByNameRegistry.get(Number(id));
  }

  @action verifyTechnicianCertificate = async (id: string) => {
    try {
      await agent.TechnicianCertificates.verify(id);
      runInAction('verifying TechnicianCertificate', () => {
        let techniciancertificatename = this.getTechnicianCertificate(id);
        techniciancertificatename.verified = "Y";
        this.employeeCertificateByNameRegistry.set(id, techniciancertificatename);
        this.employeeCertificateIdRegistry.set(techniciancertificatename.certificateId, '');
      })
    } catch (error) {
      toast.error('verify TechnicianCertificate error');
      console.log(error);
    }
  }

  @action deleteTechnicianCertificatePhoto = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.TechnicianCertificatePhotos.delete(id);
      runInAction('deleting TechnicianCertificate photo', () => {
        this.techniciancertificatephotoRegistry.delete(id);
        this.submitting = false;
        this.target = '';
        toast.success('Certificate photo deleted');
      })
    } catch (error) {
      runInAction('delete TechnicianCertificate photo error', () => {
        this.submitting = false;
        this.target = '';
      })
      toast.error('delete TechnicianCertificate photo error');
      console.log(error);
    }
  }

  @action selectEmployeeStatus = async (status: string) => {
      let employees = Array.from(this.employeeRegistry.values());
      if (status) {
        const selectedEmployees = employees.filter((employee) =>
          employee.status.toLowerCase().includes(status.toLowerCase())
        );
        this.employeeSearchRegistry.clear();
    //    runInAction("loading empolyees", () => {
          selectedEmployees.forEach((employee) => {
            employee.dob = employee.dob.substr(0, 10);
            employee.startDate = employee.startDate.substr(0, 10);
            this.employeeSearchRegistry.set(employee.email, employee);
          });
     //   });
      } else {
        this.employeeSearchRegistry.clear();
        employees = Array.from(this.employeeRegistry.values());
        employees.forEach((employee) => {
          employee.dob = employee.dob.substr(0, 10);
          employee.startDate = employee.startDate.substr(0, 10);
          if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist")
           this.employeeSearchRegistry.set(employee.email, employee);
        });
      }
  };

  //Select
  @action selectEmployeeTitle = async (title: string, text: string) => {
    let employees = Array.from(this.employeeRegistry.values());
    if (text !== 'ALL') {
      let selectedEmployees = [];
      if (title === 'department')
      {
        selectedEmployees = employees.filter((employee) =>
        employee.department.toLowerCase() === text.toLowerCase()
        );
      } 
      else if (title === 'position')
      {
        selectedEmployees = employees.filter((employee) =>
        employee.position.toLowerCase() === text.toLowerCase()
        );
      }
      this.employeeSearchRegistry.clear();
         selectedEmployees.forEach((employee) => {
          employee.dob = employee.dob.substr(0, 10);
          employee.startDate = employee.startDate.substr(0, 10);
          if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist")
          this.employeeSearchRegistry.set(employee.email, employee);
        });
    } else {
      this.employeeSearchRegistry.clear();
      employees = Array.from(this.employeeRegistry.values());
      employees.forEach((employee) => {
        employee.dob = employee.dob.substr(0, 10);
        employee.startDate = employee.startDate.substr(0, 10);
        if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist")
           this.employeeSearchRegistry.set(employee.email, employee);
      });
    }
  };

  @action uploadEmployeePhoto = async (photo : File[], email : string) => {
    if (typeof photo !== 'undefined' && photo.length === 1) 
    {  
      this.uploadingFile = true;   
    try {
      const photoUrl = await agent.Employees.uploadEmployeePhoto(photo[0], email);
      runInAction(() => {
       this.employee!.photoUrl = photoUrl.url;
       this.uploadingFile = false;
       toast.success('Employee photo uploaded successfully!');
      });
    } catch (error) {
      console.log(error);
      toast.error('Problem uploading employee photo');
      runInAction(() => {
        this.uploadingFile = false;
      });
    }
    }
    else
    {
      toast.error('Please choose one photo only!');
    }
  };

  @action deleteEmployeePhoto = async (email : string) => {
    try {
      const photoUrl = await agent.Employees.deleteEmployeePhoto(email);
      runInAction(() => {
       this.employee!.photoUrl = "";
       toast.success('Employee photo deleted successfully!');
      });
    } catch (error) {
      console.log(error);
      toast.error('Problem deleting employee photo');
      runInAction(() => {
      });
    }
  }

  @action downloadEmployeeCertificateZipFile = async (email: string, certificateId: string[]) => {
    this.loadingInitial = true;
    let certId = [];
    for (let i = 0; i < certificateId.length; i++)
    {
       const certid = {id: this.employeeCertificateByNameRegistry.get(certificateId[i]).certificateId};
       certId.push(certid);
    }
    try {
      const zipFile = await agent.Employees.download(email, certId);
      runInAction('downloading techniciancertificate photos', () => {
        this.loadingInitial = false;
      })
      return zipFile.url;
    } catch (error) {
      runInAction('download techniciancertificate photo error', () => {
        this.loadingInitial = false;
      })
      toast.error('download techniciancertificate photo error');
      console.log(error);
    }
  }

  @action loadJobPositions = async () => {
    this.loadingInitial = true;
    try {
      const jobpositions = await agent.JobPositions.list();
      runInAction("loading jobpositions", () => {
        this.jobpositionRegistry.clear();
        jobpositions.forEach((jobposition) => {
          this.jobpositionRegistry.set(jobposition.name, jobposition);
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load JobPosition List Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load JobPosition List Error");
    }
  };

  @action checkCertificate = () => {
    this.employeeNoneCertificateRegistry.clear();
    const jobposition = this.jobpositionRegistry.get(this.employee!.position);
    if ((jobposition) && (jobposition.certificateId !== ""))
    {
      const positioncert = jobposition.certificateId.split(',');
      positioncert.forEach((id: any) => {
         if (!this.employeeCertificateIdRegistry.has(Number(id)))
         {
           const cert = this.certificateRegistry.get(Number(id));
           this.employeeNoneCertificateRegistry.set(cert.id, cert);
         }
      })
    }
  };

}

export default createContext(new EmployeeStore());
